import { render, staticRenderFns } from "./confirm-invite-new-user.vue?vue&type=template&id=d8d5836c"
import script from "./confirm-invite-new-user.vue?vue&type=script&lang=js"
export * from "./confirm-invite-new-user.vue?vue&type=script&lang=js"
import style0 from "./confirm-invite-new-user.vue?vue&type=style&index=0&id=d8d5836c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8d5836c')) {
      api.createRecord('d8d5836c', component.options)
    } else {
      api.reload('d8d5836c', component.options)
    }
    module.hot.accept("./confirm-invite-new-user.vue?vue&type=template&id=d8d5836c", function () {
      api.rerender('d8d5836c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/confirm-invite-new-user.vue"
export default component.exports